import React, { useEffect, useState } from "react";
import {
    Alert,
    AlertTitle,
    Box
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import usePrivilegeCheck from "../../../constants/customHooks/UsePrivilegeCheck";
import ContactTable from "./ContactTable";
import { findContactMessagesAction } from "../../../actions/LandingPageAction";

function ContactMain(props) {
    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const { fetchContactMessagesSuccess } = useSelector((s) => s.fetchEnquiry);

    useEffect(() => {
        dispatch(findContactMessagesAction());
    }, [dispatch]);

    useEffect(() => {
        if (fetchContactMessagesSuccess?.data) {
            setData(fetchContactMessagesSuccess.data)
        }
    }, []);

    const columns = [
        {
            field: "SL NO",
            title: "SL NO"
        },
        {
            field: "Date",
            title: "Date"
        },
        {
            field: "Name",
            title: "Name"
        },
        {
            field: "Email",
            title: "Email"
        },
        {
            field: "Phone",
            title: "Phone"
        },
        {
            field: "Message",
            title: "Message"
        },
    ];

    return (
        <Box>
            <ContactTable data={data} columns={columns} />
        </Box>
    );
}

export default ContactMain;
